<template>
    <v-select  v-model="edrpou"
               @search="onSearchname"
               label="name"
               :filterable="false"
               :options=multi_edrpoг_filtered  >
        <template slot="no-options">
            Починайте вводити назву контрагента
        </template>
        <template slot="option" slot-scope="option">
            <div class="d-center">
                {{ option.name }}
                <small >{{option.edrpou}}</small>
            </div>
        </template>
    </v-select>
</template>

<script>
import vSelect from 'vue-select'

export default {
    name: "c_name",


    props :{
        row : {
            type : Object,
            required: true
        }
    },

    components : {
        vSelect
    },

    data() {
        return {
            multi_edrpou : []

        }

    },

    created() {

    },

    methods: {
        onSearchname(search, loading) {
            if(search.length > 3) {
                loading(true);
                this.searchname(loading, search);
            }
        },

        async searchname(loading, search)  {
            let names = [];

            names.push(search);
            await api.post('/organizations/1c/getOrgbyName',{codes : names}).then(({data}) => {
                console.log("1c",data);
                loading(false);
                this.multi_edrpou =[];
                if(data.status == "operation_success") {
                    this.multi_edrpou = data.data;
                }

            }).catch(err => {
                loading(false);

            });


        },

    },

    computed : {
        multi_edrpoг_filtered() {
           if(this.multi_edrpou.length > 0) {
               return this.multi_edrpou.map((element, index) =>{

                   element.key = index
                   return element
               })
           }

           return [];
        },

        edrpou :{
            set: function (val)  {
                if (val == null) {
                    this.worked_doc.edrpou = '';
                    this.worked_doc.name = '';
                }
                else {
                    if (val.edrpou == ''){
                        this.worked_doc.name = val.name;
                    }
                    else {
                        this.worked_doc.edrpou = val.edrpou;
                        this.worked_doc.name = val.name;
                    }

                }
            },
            get: function () {
                return this.worked_doc.name;
            }
        },
        worked_doc : {
            set: function (val)  {
                this.row = val;
            },
            get: function () {
                return this.row;
            }
        },



    }

}
</script>

<style scoped>

</style>